import React from 'react';
import { buildUrl, VALID_URLS } from 'Douleutaras/utilities/url-builder';

import './CategoryLink.scss';

export interface CategoryLinkProps {
  id: string;
  title: string;
}

export const CategoryLink = ({ id, title }: CategoryLinkProps) => (
  <li styleName="related-services__item">
    <a href={buildUrl(VALID_URLS.CATEGORY, id)} styleName="related-services__link">{title}</a>
  </li>
);

export default CategoryLink;
